import * as React from "react";

import HeroSection from "./common/hero_section/hero_section";
import Header from "../../common/header/header";
import DroneCatalogPage from "./common/filter_drone_section/drone_catalog";
import RentOutSection from "./common/rent_out_section/rent_out_section";
import BrandsSection from "./common/brands/brands";
import Footer from "../../common/footer/footer";
import CallToAction from "./common/call_to_action/call_to_action";
const HomePage: React.FC = () => {
  const [searchText, setSearchText] = React.useState<string>("");
  const [selectedCity, setSelectedCity] = React.useState<string>("");
  return (
    <div className="w-full">
      <Header className="px-10 py-4" />
      <div className="w-full h-full size-max -mt-[104px]">
        <HeroSection
          searchText={searchText}
          setSearchText={setSearchText}
          selectedCity={selectedCity}
          setSelectedCity={setSelectedCity}
        />
        <DroneCatalogPage
          searchText={searchText}
          selectedCity={selectedCity}
        />
      </div>
      <div>
        <RentOutSection />
        <BrandsSection />
        <CallToAction />
        <Footer />
      </div>
    </div>
  );
};

export default HomePage;
